import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PrintDocument from '../../common/PrintDocument';

const DetailsPageActions = ({ data }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const onClickBackButton = () => {
    return navigate('/self-billed-documents?tab=self-billed-debit-notes');
  };

  return (
    <>
      <Grid>
        {data?.irbm_response?.status === 'Valid' && (
          <PrintDocument documentType={[data.document_type]} documentId={data.document_id} />
        )}
        <Button
          key="back"
          variant="contained"
          color="primary"
          onClick={onClickBackButton}
          className="action-button"
          sx={{ marginLeft: theme.spacing(1) }}
        >
          Back
        </Button>
      </Grid>
    </>
  );
};

export default DetailsPageActions;
